import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Card,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "@material-ui/icons/Search";
//import DeleteIcon from '@material-ui/icons/Delete'; SE COMENTA HASTA REVISAR ALCANCE DEL REQUIRIMIENTO
import { red } from "@material-ui/core/colors";
import { Redirect } from "react-router-dom";
import {
  desSeleccionarAfiliadoNuevo,
  traerAfliadoPorCuilBandeja,
} from "../../../actions/preAfiliado/afiliado";
import { changeStepper } from "../../../actions/preAfiliado/stepper";
import { estados } from "../../../helpers/estados";
import { DialogInfo } from "./DialogInfo";
import { fetchConToken } from "../../../helpers/fetch";
import moment from "moment";
import { startAlerta } from "../../../actions/ui/alertas";
//import {fetchBandejaEliminar} from "../../../actions/bandeja"; SE COMENTA HASTA REVISAR ALCANCE DEL REQUIRIMIENTO

const useStyles = makeStyles({
  root: {
    boxShadow: "none",
  },
  expandIcon: {
    "&$expanded": {
      transform: "rotate(0deg)",
    },
  },
  expanded: {},
});

export const ListaItems = ({ esAreaUno, nombreBandeja, ...props }) => {
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.bandeja);
  const [open, setOpen] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [afiliadoSelec, setAfiliadoSelec] = useState({});
  const [bandejaFamiliar, setBandejaFamiliar] = useState(false);
  const [empresas, setEmpresas] = useState([]);
  const [desdeAceptadas, setDesdeAceptadas] = useState(false);

  const classes = useStyles();
  
  props.estadoPreAfiliadoHandler(null);

  /* Cuando busco un PreAfiliado, solo hay uno, me quedo con el estado para marcar la solapa */
  if (items?.length === 1) {
    props.estadoPreAfiliadoHandler(items[0].estado);
  }

  const handleClick = async (afiliado) => {
    if ( afiliado.estado === estados.Preafiliacion_BandejaNacionalAprobada ) {
      const response = await fetchConToken(
        `Afiliados/traerTitularPorCUIL/${afiliado.cuil}`
      );

      if ( response.ok ) {
        const contentType = response.headers.get( "content-type" );

        if ( contentType && contentType.indexOf("application/json") !== -1 ) {
          const titular = await response.json();

          if ( !!titular ) {
            setAfiliadoSelec( titular );
          }
        }
      }
      setDesdeAceptadas(true);
      setRedirect(true);
    } else {
      setDesdeAceptadas(false);
      if (
        esAreaUno &&
        (afiliado.estado === estados.Preafiliacion_BandejaNacionalModificada ||
          afiliado.estado === estados.Preafiliacion_BandejaNacional ||
          afiliado.estado === estados.Preafiliacion_PresencialIngresada)
      ) {
        dispatch(
          startAlerta(`Esta Preafiliacion ya fue enviada`, "warning", "Aviso")
        );
      } else {
        if (afiliado.tipo === 2) {
          setBandejaFamiliar(true);
        }
        if (afiliado.estado === estados.Preafiliacion_BandejaNacionalAprobada) {
          setAfiliadoSelec(afiliado);
          const response = await fetchConToken(
            `EmpresasPreAfiliados/${afiliado.id_afiliado}`
          );
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            if (lista.length > 0) {
              setEmpresas(lista);
            }
          }
          dispatch(desSeleccionarAfiliadoNuevo());
          setOpen(true);
        } else {
          dispatch(desSeleccionarAfiliadoNuevo());
          dispatch(
            traerAfliadoPorCuilBandeja(afiliado.cuil, afiliado.idGrupoFamiliar)
          );
          dispatch(changeStepper(0));
          setRedirect(true);
        }
      }
    }
  };

  /* SE COMENTA HASTA REVISAR ALCANCE DEL REQUIRIMIENTO
  const handleDelete = async (afiliado) => {
    dispatch(fetchBandejaEliminar(afiliado.id_afiliado));
  } */

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <DialogInfo
        open={open}
        handleClose={handleClose}
        afiliadoSelec={afiliadoSelec}
        empresas={empresas}
      />
      {items.length > 0 ? (
        <Grid container>
          <Grid Item xs={12}>
            <Typography variant="h5" align="center" color="secondary" paragraph>
              {nombreBandeja}
            </Typography>
          </Grid>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ minHeight: "25vh" }}
          >
            <Card className={classes.root}>
              <TableContainer component={Paper}>
                <Table
                  style={{
                    marginLeft: 15,
                    marginRight: 15,
                    marginBottom: 15,
                    width: 850,
                  }}
                >
                  <TableBody>
                    {items.map((item) => {
                      const styleRow = {
                        color: "#000",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }; /* (item.estado === estados.Preafiliacion_BandejaSeccional || (item.estado === estados.Preafiliacion_BandejaNacional && !esAreaUno)) 
                      ? {color: blue[500], cursor: "pointer"} : ((item.estado === estados.Preafiliacion_BandejaSeccionalModificada || item.estado === estados.Preafiliacion_PresencialNuevo)
                      ? {color: orange[500], cursor: "pointer"} : (((item.estado === estados.Preafiliacion_BandejaNacionalObservada && esAreaUno) || item.estado === estados.Preafiliacion_BandejaNacionalModificada) 
                      ? {color: lime[500], cursor: "pointer"} : (((item.estado === estados.Preafiliacion_BandejaNacional && esAreaUno) || item.estado === estados.Preafiliacion_BandejaNacionalAprobada || item.estado === estados.Preafiliacion_PresencialIngresada) 
                      ? {color: green[500], cursor: "pointer"} : {color: red[500], cursor: "pointer"}
                      ))); */

                      const observaciones = item?.observaciones?.length > 0 ? [...item.observaciones] : null;

                      if (nombreBandeja === "Ingresadas Seccional" && !!observaciones) {
                    
                        observaciones?.sort( ( b, a ) => {
                          const fecha1 = new Date(a.fecha)
                          const fecha2 = new Date(b.fecha)
                          if ( fecha1 > fecha2 ) {
                            return 1;
                          } else if ( fecha2 > fecha1 ) {
                            return -1;
                          } else {
                            return 0;
                          } 
                        });
                      }
                      return (
                        <Accordion
                          TransitionProps={{ unmountOnExit: true }}
                          key={item.cuil}
                          style={{
                            backgroundColor: item.tipo === 2 ? "#fff7f0" : "",
                          }}
                          elevation={0}
                          classes={{
                              root: classes.MuiAccordionroot
                          }}
                        >
                          <AccordionSummary
                            classes={{
                              expandIcon: classes.expandIcon,
                              expanded: classes.expanded,
                            }}
                            expandIcon={
                              nombreBandeja !== "Observadas" ? (

                                  <SearchIcon
                                    style={{ margin: 10, cursor: "pointer" }}
                                    fontSize="large"
                                    onClick={() => {
                                      handleClick(item);
                                    }}
                                    />
                                
                              ) : null
                            }
                          >
                            {/* SE COMENTA HASTA REVISAR ALCANCE DEL REQUIRIMIENTO
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <DeleteIcon 
                                style={{ margin: 10, cursor: "pointer", color: "#cd5c5c" }}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                fontSize="large"
                                onClick={() => {
                                  handleDelete(item);
                                }}
                              />
                              </Box> */}
                            <TableCell
                              align="left"
                              style={{ width: 680, borderBottom: "none" }}
                            >
                              {nombreBandeja === "Ingresadas Seccional" && item?.observaciones?.length > 0 && <div>
                                
                                <span style={{fontStyle: "italic", color: "#cd5c5c"}}>{`Observada por ${item.observaciones[0]?.usuario?.userName}`}</span>
                              </div>}
                              <div
                                style={styleRow}
                                onClick={() => {
                                  handleClick(item);
                                }}
                              >
                                {item.apellido_y_nombre &&
                                  item.apellido_y_nombre.toUpperCase()}
                                {item.tipo === 2 && (
                                  <span
                                    style={{
                                      color: "black",
                                      fontWeight: "bold",
                                      float: "right",
                                    }}
                                  >
                                    Lote Familiar
                                  </span>
                                )}  
                                     {item.cuil_inactivo && item.tipo === 1 &&(
                                  <span
                                    style={{
                                      color: "orange",
                                      fontWeight: "bold",
                                      float: "right",
                                    }}
                                  >
                                    CUIL Inactivo AFIP
                                  </span>
                                )}
                              </div>
                              <div>{item?.cuil}</div>
                              {item?.usuario_tomada && (
                                <div style={{ color: red[500] }}>
                                  Tomada por: {item?.usuario_tomada}
                                </div>
                              )}

                              <div>
                                {moment(item?.fecha_alta).format("DD/MM/YYYY")}
                              </div>
                              <div>
                                {item.usuario && item.usuario.toUpperCase()}
                              </div>
                              <div>
                                {item.seccional && item.seccional.toUpperCase()}
                              </div>
                            </TableCell>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div
                              style={{
                                marginLeft: 15,
                                width: "90%",
                                margin: "auto",
                              }}
                            >
                              <Box mb={2}>
                                <Grid container spacing={2}>
                                  {item.familiares &&
                                    item.familiares.length > 0 &&
                                    item.familiares.map((familiar) => {
                                      return (
                                        <Grid
                                          item
                                          xs={12}
                                          key={familiar.idAfiliado}
                                        >
                                          <Paper className={classes.paper}>
                                            {familiar.apellidoNombre}
                                          </Paper>
                                        </Grid>
                                      );
                                    })}
                                </Grid>
                              </Box>
                              {item?.estado !== estados.Preafiliacion_BandejaNacionalAprobada && item?.observaciones &&
                                item.observaciones.map((observacion) => {
                                  return (
                                    <Typography paragraph>
                                      {`${observacion.usuario.userName}: ${observacion.mensaje}`}
                                    </Typography>
                                  );
                                })}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              {redirect && (
                <Redirect
                  to={{
                    pathname: "/afiliaciones",
                    state: {
                      from: props.location.pathname,
                      familiar: bandejaFamiliar,
                      desdeAceptadas: desdeAceptadas,
                      afiliadoSelec: afiliadoSelec
                    },
                  }}
                />
              )}
            </Card>
          </Grid>
        </Grid>
      ) : null}
    </>
  );
};
